import React from 'react';
import {CellProps, HeaderProps, Hooks} from 'react-table';

import {TableSelectionCheckbox} from './tableSelectionCheckbox';

/**
 * Custom react-table plugin which adds a column in first position for row selection.
 * As per https://react-table.tanstack.com/docs/examples/row-selection-and-pagination.
 */

export const useAddSelectionColumn = <T extends object = {}>(hooks: Hooks<T>) => {
  hooks.visibleColumns.push((visiblesColumns) => [
    {
      id: 'selection',
      Header: renderHeader,
      Cell: renderCell,
    },
    ...visiblesColumns,
  ]);
};

/*
 * Helpers.
 */

function renderHeader<T extends object = {}>(headerProps: HeaderProps<T>) {
  // getToggleAllRowsSelectedProps will select all the rows.
  // If needed, use getToggleAllPageRowsSelectedProps to only select the rows of the current page
  return <TableSelectionCheckbox {...headerProps.getToggleAllRowsSelectedProps()} />;
}

function renderCell<T extends object = {}>(cellProps: CellProps<T, any>) {
  return <TableSelectionCheckbox {...cellProps.getToggleRowSelectedProps()} />;
}
